import { Helmet } from "react-helmet-async";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";
import { Button, Card, Col, Container, Form } from "react-bootstrap";
import TableForm from "../../../components/TableForm";
import ConfirmModal from "../../../components/ConfirmModal";

export default function EditBranchInformation() {
  const navigate = useNavigate();
  const { id } = useParams();
  const { user } = useAuth();
  const [showModal, setShowModal] = useState(false);
  const [validated, setValidated] = useState(false);
  const defaultData = {
    BP_Code: null,
    Branch_Code: "",
    Branch_Name: "",
    Branch_Status: "",
    Com_Code: user.Com_Code
  };
  const [data, setData] = useState({ Array: [defaultData] });
  const inputField = [
    { name: "BP_Code", label: "BP Code", type: "text", readOnly: true },
    { name: "Branch_Code", label: "รหัสสาขา", type: "text", readOnly: true },
    { name: "Branch_Name", label: "ชื่อสาขา", type: "text", readOnly: true },
    {
      name: "Branch_Status",
      label: "สถานะ",
      type: "select",
      noneAsync: true,
      options: [
        { value: "true", label: "ใช้งาน" },
        { value: "false", label: "ไม่ใช้งาน" }
      ]
    }
  ];

  const handleValidated = (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (!form.checkValidity()) {
      event.stopPropagation();
      setValidated(true);
    } else {
      setShowModal(true);
    }
  };

  const handleSubmit = (event, { dataCallback, showCallback }) => {
    event.preventDefault();
    setShowModal(showCallback);

    if (dataCallback) {
      console.log(dataCallback);
    }
  };

  return (
    <>
      <Helmet>
        <title>แก้ไขสถานะสาขา</title>
        <meta name="description" content="Check Branch Status Page" />
      </Helmet>

      <Container fluid className="p-3">
        <Form noValidate validated={validated} onSubmit={handleValidated}>
          <Card className="m-1 mb-4 p-4 border-0">
            <Card.Header className="p-3 bg-transparent border-bottom-0">
              <Card.Title className="fs-2 text-center">
                แก้ไขสถานะสาขา
              </Card.Title>
            </Card.Header>

            <Card.Body>
              <TableForm
                editForm
                data={data.Array}
                columns={inputField}
                defaultData={defaultData}
                onChangeCallback={(newData) => setData({ Array: newData })}
              />
            </Card.Body>

            <Card.Footer className="p-3  text-end bg-transparent border-top-0">
              <Col>
                <Button
                  type="submit"
                  variant="success"
                  className="me-2 px-5 py-2 text-dark rounded-pill"
                >
                  บันทึกการแก้ไข
                </Button>
                <ConfirmModal
                  show={showModal}
                  data={data}
                  content="edit"
                  onSubmitCallback={handleSubmit}
                />

                <Button
                  variant="outline-success"
                  className="px-5 py-2 text-dark border-dark border-opacity-50 rounded-pill"
                  onClick={() => navigate(-1)}
                >
                  ยกเลิก
                </Button>
              </Col>
            </Card.Footer>
          </Card>
        </Form>
      </Container>
    </>
  );
}
